<template>
	<div class="row" v-if="ready">
		<div v-if="authorized.database_exportable" class="col-xs-12" style="margin-bottom: 15px">
			<a href="{{exportPath}}" class="btn btn-primary pull-right">Export Database</a>
		</div>

		<div class="clearfix"></div>

		<yeast-types></yeast-types>
		<varietals></varietals>
		<regions></regions>

		<div class="clearfix"></div>

		<what-now></what-now>

	</div>
</template>

<script>
	import WhatNow from './partials/what-now'
	import Varietals from './partials/varietals'
	import YeastTypes from './partials/yeast-types'
	import Regions from './partials/regions'
	import { App as AppActions } from 'vx/actions'
	import { authorized } from 'vx/getters'
	import Notify from 'utils/notify'
	import Http from 'utils/http'
	import Alert from 'utils/alert'

	export default {
		components: {
			WhatNow,
			YeastTypes,
			Varietals,
			Regions
		},

		vuex: {
			actions: {
				setTitle: AppActions.title
			},
			getters: {
				authorized
			}
		},

		ready() {
			this.setTitle('Admin Settings');

			if (this.authorized.access < 30) {
				this.$router.go({ name: 'dashboard' });

				Notify.error('You do not have the required permissions.');
			} else {
				this.ready = true;
			}
		},

		data() {
			return {
				ready: false,
				exportPath: Http.buildPath('export-database')
			}
		},

		methods: {
			exportDb() {
				// generate loading effect
				Http.get('export-database').then(response => {
					// stop loading
				}).catch(error => {
					// stop loading
					console.warn(error)
				})
			}
		}
	}
</script>



// WEBPACK FOOTER //
// index.vue?6ada38c4